import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const sltMobile = definePartsStyle({
    container: defineStyle({
        border: 'none',
        padding: 0,
    }),
    button: defineStyle({
        padding: 0,
        textStyle: 'body-base',
        color: 'slt-black.1000',
        fontWeight: 400,
        _expanded: {
            fontWeight: 600,
        },
    }),
    panel: defineStyle({
        textStyle: 'body-base',
        paddingX: 6,
        paddingY: 4,
    }),
});

const baseContainer = defineStyle({
    paddingTop: 4,
    paddingBottom: 4,
});

const baseButton = defineStyle({
    textStyle: 'body-base',
    color: 'slt-pepper.1000',
    paddingX: 0,
    paddingY: 2,
    _hover: {
        background: 'none',
    },
    _focus: {
        boxShadow: 'unset',
    },
});

const basePanel = defineStyle({
    textStyle: 'body-base',
    color: 'slt-pepper.1000',
    margin: 0,
    paddingX: 0,
    paddingTop: 4,
    paddingBottom: 0,
});

const baseStyle = definePartsStyle({
    button: baseButton,
    panel: basePanel,
    container: baseContainer,
});

const plpCategories = definePartsStyle({
    container: {
        ...baseContainer,
        paddingTop: 0,
        paddingBottom: 0,
        marginInlineStart: 4,
    },
    button: baseButton,
    panel: {
        ...basePanel,
        paddingTop: 4,
        paddingBottom: 0,
    },
    root: {
        paddingTop: 0,
        paddingBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
});

export const Accordion = defineMultiStyleConfig({
    baseStyle,
    variants: {
        'slt-mobile': sltMobile,
        'plp-categories': plpCategories,
    },
});
